import React, { PureComponent } from 'react'
import ReactTooltip from 'react-tooltip'
// components
import Layout from 'pages/Layout'
import TermsAndConditions from 'pages/TermsAndConditions/index'
import NavBar from 'pages/NavBar'
import Sidebar from 'pages/Sidebar'
import Loader from 'components/Loader'
import ModalLogin from 'components/ModalAuth/index'
import LogIn from './Auth/LogIn'
import OtpLogIn from './Auth/OtpLogIn'
import SignUp from './Auth/SignUp'
import CreatePassword from './Auth/CreatePassword'
import CheckConfirmation from './Auth/CheckConfirmation'
import RecruiterInvitation from './Auth/RecruiterInvitation'
import ResetPassword from './Auth/ResetPassword'
import Support from 'pages/Support'
import GuestJobs from 'pages/Guest/Jobs'
import CandidateInvitation from './Auth/CandidateInvite'
import RememberAndRedirect from 'components/RememberAndRedirect'
import DeleteAccount from 'pages/DeleteAccount'
import Privacy from './Privacy'
import Consent from 'pages/Consent'
import UiButtonDemo from 'components/ui/Button/demo'
// redux
import { Redirect, Route, Switch, withRouter, RouteComponentProps } from 'react-router'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { routes } from 'domain/router/routes'
import {
  isAuthorizedSelector,
  userSelector,
  recruiterAccept,
  acceptRecommendJob,
  signOut
} from 'domain/env'
import { pageIsLoadingSelector } from 'domain/loading'
// types
import { ComposeType, UserType } from 'types/common'
import { Classes } from 'jss'
import { StateInterface } from 'types/state'
// styles
import injectSheet from 'react-jss'
import { sheet } from './sheet'
// utils
import AsyncRoute from 'lib/asyncRoute'
import { StateSignUp } from './Auth/SignUp/types'

interface Props extends RouteComponentProps {
  classes: Classes
  style?: React.CSSProperties
  isAuthorized: boolean | null
  pageIsLoading: boolean
  user: UserType
  acceptInvitation: (data: object) => void
  acceptRecommendation: (data: object) => void
  signOut: (action: any) => void
}

class App extends PureComponent<Props, { isOpenMobileSidebar: boolean }> {
  state = {
    isOpenMobileSidebar: false
  }

  confirmText = () => (
    <>
      <Layout />
      <ModalLogin modalComponent={{ component: CheckConfirmation }} disableClickAway />
    </>
  )

  logIn = () => (
    <>
      <Layout />
      <ModalLogin modalComponent={{ component: LogIn }} disableClickAway />
    </>
  )

  logInOtp = () => (
    <>
      <Layout />
      <ModalLogin modalComponent={{ component: OtpLogIn }} disableClickAway />
    </>
  )

  signUp = () => (
    <>
      <Layout />
      <ModalLogin modalComponent={{ component: SignUp }} disableClickAway />
    </>
  )

  createPassword = () => (
    <>
      <Layout />
      <ModalLogin modalComponent={{ component: CreatePassword }} disableClickAway />
    </>
  )

  inviteRecruiter = () => (
    <>
      <Layout />
      <ModalLogin
        modalComponent={{
          component: RecruiterInvitation,
          props: {
            acceptingRole: StateSignUp.Recruiter,
            acceptInvitation: this.props.acceptInvitation
          }
        }}
        disableClickAway
      />
    </>
  )

  inviteCandidate = () => (
    <>
      <Layout />
      <ModalLogin modalComponent={{ component: CandidateInvitation }} />
    </>
  )

  acceptRecommendations = () => (
    <>
      <Layout />
      <ModalLogin
        modalComponent={{
          component: RecruiterInvitation,
          props: {
            acceptingRole: StateSignUp.Candidate,
            acceptInvitation: this.props.acceptRecommendation
          }
        }}
        disableClickAway
      />
    </>
  )

  resetPassword = () => (
    <>
      <Layout />
      <ModalLogin modalComponent={{ component: ResetPassword }} disableClickAway />
    </>
  )

  toggleSidebarMenu = () => {
    this.setState(prevState => ({ isOpenMobileSidebar: !prevState.isOpenMobileSidebar }))
  }

  render() {
    const { isAuthorized, classes, user, pageIsLoading } = this.props
    const { isOpenMobileSidebar } = this.state
    const role = user.get('role')
    const redirectPath = '/dashboard'
    if (isAuthorized === null) {
      return null
    }
    return !isAuthorized ? (
      <React.Fragment>
        <main className={classes.main}>
          <Loader show={pageIsLoading} />
          <Switch>
            <Route exact={true} path="/" component={Layout} />
            <Route path="/terms_and_conditions" component={TermsAndConditions} />
            <Route path="/account/how-to-delete" component={DeleteAccount} />
            <Route path="/account/confirmation" component={() => null} />
            <Route path="/account/check-confirmation" component={this.confirmText} />
            <Route path="/privacy" component={Privacy} />
            <Route path="/log-in-otp" exact={true} component={this.logInOtp} />
            <Route path="/log-in" component={this.logIn} />
            <Route path="/sign-up" component={this.signUp} />
            <Route path="/account/password-reset" component={this.createPassword} />
            <Route path="/recruiter-invite" component={this.inviteRecruiter} />
            <Route path="/guest/job/:id" component={this.acceptRecommendations} />
            <Route path="/reset-password" component={this.resetPassword} />
            <Route path="/guest/jobs" component={GuestJobs} />
            <Route path="/jobs" component={GuestJobs} />
            <Route path="/find-jobs" component={GuestJobs} />
            <Route path="/candidate-invite" component={this.inviteCandidate} />
            <Route exact={true} path="/ui/Button" component={UiButtonDemo} />
            <Route
              render={() => {
                return <RememberAndRedirect to="/" />
              }}
            />
          </Switch>
        </main>
      </React.Fragment>
    ) : (
      <React.Fragment>
        <main className={classes.root}>
          <Loader show={pageIsLoading} />
          <div className={classes.rootContainer}>
            <Sidebar
              isOpenMobileSidebar={isOpenMobileSidebar}
              toggleSidebarMenu={this.toggleSidebarMenu}
            />
            <NavBar toggleSidebarMenu={this.toggleSidebarMenu} />
            <Switch>
              <Route exact={true} path="/support" component={Support} />
              <Route exact={true} path="/consent" component={Consent} />
              <Route exact={true} path="/ui/Button" component={UiButtonDemo} />
              {/* prevent fallback redirect during auth transitions */}
              <Route exact path="/log-in" render={() => null} />
              <Route exact path="/log-in-otp" render={() => null} />

              {routes[role].map((router, idx) => {
                return <AsyncRoute key={idx} path={router.path} import={router.component} />
              })}
              <Redirect to={redirectPath} />
            </Switch>
            {isOpenMobileSidebar && (
              <div className={classes.openSidebarOverlay} onClick={this.toggleSidebarMenu} />
            )}
          </div>
          <ReactTooltip multiline={true} place="bottom" effect="solid" />
        </main>
      </React.Fragment>
    )
  }
}

export default compose<ComposeType<Props>>(
  withRouter,
  connect(
    (state: StateInterface) => ({
      pageIsLoading: pageIsLoadingSelector(state),
      isAuthorized: isAuthorizedSelector(state),
      user: userSelector(state)
    }),
    { acceptInvitation: recruiterAccept, acceptRecommendation: acceptRecommendJob, signOut }
  ),
  injectSheet(sheet)
)(App)
